import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { PATH_ROOT, PATH_PROJECTS_CONTRACTOR_CARDS } from "@/constants";
import { useContractorCardContext } from "../context";

export const useContractorCardBreadcrumb = (): BreadcrumbItem[] => {
  const { t } = useTranslation();
  const { data } = useContractorCardContext();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("contractorCards.title.multiple"),
        href: PATH_PROJECTS_CONTRACTOR_CARDS,
      },
    ];

    if (data) {
      breadcrumbItems.push({
        label: data.id,
      });
    } else {
      breadcrumbItems.push({
        label: t("contractorCards.title.single"),
      });
    }

    return breadcrumbItems;
  }, [t, data]);
};
